import { ShapeType } from '@/services/shape';
import { getImageObject, getLayerRecolorEnabled, getRefName } from '../utils';

export function DataItemImageNumberLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    images: getImageObject(resAst, getRefName(layerAst.attrsMap.ref), colors),
    decimalIcon: getImageObject(
      resAst,
      getRefName(layerAst.attrsMap.decimalIcon),
      colors
    ),
    unitIcon: getImageObject(
      resAst,
      getRefName(layerAst.attrsMap.unitIcon),
      colors
    )
  };
  const { attrsMap } = layerAst;
  const { rotation = '0', leadingZero, unitIcon, ref } = attrsMap;
  layer.attrs.sourceFormat =
    leadingZero == 'true' ? (unitIcon ? 4 : 2) : unitIcon ? 3 : 1;
  layer.attrs.recolorEnable = getLayerRecolorEnabled(resAst, getRefName(ref));
  layer.attrs = { ...attrsMap, ...layer.attrs };
  layer.attrs.fillType = '数字填充';
  layer.attrs.rotation = Number(rotation);
  layer.type = ShapeType.ImageArray;
}
